var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83325 2.66732C5.25592 2.66732 3.16659 4.75666 3.16659 7.33398C3.16659 9.91131 5.25592 12.0007 7.83325 12.0007C10.4106 12.0007 12.4999 9.91131 12.4999 7.33398C12.4999 4.75666 10.4106 2.66732 7.83325 2.66732ZM1.83325 7.33398C1.83325 4.02028 4.51954 1.33398 7.83325 1.33398C11.147 1.33398 13.8333 4.02028 13.8333 7.33398C13.8333 10.6477 11.147 13.334 7.83325 13.334C4.51954 13.334 1.83325 10.6477 1.83325 7.33398Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3618 10.8632C11.6221 10.6029 12.0442 10.6029 12.3046 10.8632L14.9712 13.5299C15.2316 13.7902 15.2316 14.2124 14.9712 14.4727C14.7109 14.7331 14.2888 14.7331 14.0284 14.4727L11.3618 11.806C11.1014 11.5457 11.1014 11.1236 11.3618 10.8632Z",
    fill: "#374151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16675 7.33268C5.16675 6.96449 5.46522 6.66602 5.83341 6.66602H9.83342C10.2016 6.66602 10.5001 6.96449 10.5001 7.33268C10.5001 7.70087 10.2016 7.99935 9.83342 7.99935H5.83341C5.46522 7.99935 5.16675 7.70087 5.16675 7.33268Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfZoomOut);
export default __webpack_public_path__ + "static/media/pdf-zoom-out.3cb8f51f48f8b838eee2996d5562d954.svg";
export { ForwardRef as ReactComponent };